export class ConstRoleName {
    public static Admin: string = "admin";
    public static User: string = "employee";
    public static Accountant: string = "accountant";
    public static Client: string = "client";
    public static Contractor: string = "contractor";
    public static ProjectManager: string = "manager";
    public static ProgramManager: string = "program manager";
    public static TimesheetApproval: string = "timesheet approval";
    public static SuperAdmin: string = "super admin";
  }
  